"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.KeySourceEl = void 0;
const Key_1 = require("./Key");
const util_1 = require("./util");
class KeySourceEl {
    constructor(el, opts) {
        this.el = el;
        this.filter = (0, util_1.resolveFilter)(opts?.filter);
    }
    bind(sink) {
        const filter = this.filter;
        const onKeyDown = (event) => {
            if (filter && !filter(event))
                return;
            const key = Key_1.Key.fromEvent(event);
            sink.onPress(key);
        };
        const onKeyUp = (event) => {
            if (filter && !filter(event))
                return;
            const key = Key_1.Key.fromEvent(event);
            sink.onRelease(key);
        };
        const onReset = () => {
            sink.onReset();
        };
        const onFocus = () => {
            sink.onFocus();
        };
        const el = this.el;
        const doc = typeof document !== 'undefined' ? document : void 0;
        el?.addEventListener('keydown', onKeyDown);
        el?.addEventListener('keyup', onKeyUp);
        el?.addEventListener('focus', onFocus);
        el?.addEventListener('blur', onReset);
        el?.addEventListener('compositionstart', onReset);
        el?.addEventListener('compositionend', onReset);
        doc?.addEventListener('fullscreenchange', onReset);
        return () => {
            el?.removeEventListener('keydown', onKeyDown);
            el?.removeEventListener('keyup', onKeyUp);
            el?.removeEventListener('focus', onFocus);
            el?.removeEventListener('blur', onReset);
            el?.removeEventListener('compositionstart', onReset);
            el?.removeEventListener('compositionend', onReset);
            doc?.removeEventListener('fullscreenchange', onReset);
        };
    }
}
exports.KeySourceEl = KeySourceEl;
